module.exports = __webpack_public_path__ + "img/lieve-tandarts-liggend.b8c09977.png";